import * as React from "react";
import moment from "moment-jalaali";
import {Col, Form, Input, Row, InputNumber} from "antd";
import {SupplierPayment} from "@models/supplier";
import TextEditor, {TextEditorRef} from "@components/custom/TextEditor";
import {FormattedMessage} from "react-intl";
import withFormWrapper from "@hocs/withFormWrapper";
import {SelectionMode} from '@models';
import {Supplier} from '@models/supplier';
import DatePicker from "react-datepicker2";
import {toUTC, showDate} from "@utils";
import SuppliersSelection from "@components/supplier/Selection";
import {Supplier} from "@models/supplier";


interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  supplierPayment?: SupplierPayment;
}


type PaymentFormAllProps = PropsFromState ;

type PaymentFormStateShape = {
  payment_at: string;
  description: string;
  amount: Supplier | null;
};


class PaymentForm extends React.Component<PaymentFormAllProps,
  PaymentFormStateShape> {
  constructor(props) {
    super(props);
    const {supplierPayment} = props;
    this.state = {
      ...this.getStateFromProps(supplierPayment)
    };
  }
  
  private textEditorRef = React.createRef<TextEditorRef>();
  
  getStateFromProps = (supplierPayment: SupplierPayment | null) => {
    const obj = supplierPayment || {};
    return {
      supplier: obj.supplier,
      description: obj.description || "",
      payment_at: obj.payment_at && obj.payment_at != "0001-01-01T00:00:00" ? moment(showDate(obj.payment_at)) : null,
      amount: obj ? obj.amount : "",
      id: obj.id,
    };
  };
  
  getValues = () => {
    let returnValues = null;
    this.props.form.setFieldsValue({
      "supplier_id": this.state.supplier && this.state.supplier.id,
      "payment_at": this.state.payment_at ? new Date(toUTC(this.state.payment_at)).toISOString() : null, //
    });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
        };
      }
    });
    
    return {
      payload: returnValues,
      id: this.props.supplierPayment ? this.props.supplierPayment.id : null
    };
  };
  
  onChangeSupplier = (supplier: Supplier): void => {
    this.setState({
      supplier
    });
  };
  
  onChangeDate = date => {
    this.setState({
      payment_at: date
    });
  };
  
  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form className={'supplierPayment-form'}>
        <Row>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.supplier" defaultMessage={`Supplier`}/>}>
              {getFieldDecorator("supplier_id", {
                initialValue:  this.state.supplier,
                rules: [{
                  required: true,
                  message: (
                    <FormattedMessage
                      id={`app.supplier_is_required`}
                      defaultMessage={`Supplier is required!`}
                    />
                  )
                }]
              })(
                <SuppliersSelection
                  disabled={this.state.id ? true : false}
                  mode={SelectionMode.DEFAULT}
                  initialValue={this.state.supplier}
                  onChange={this.onChangeSupplier}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.amount" defaultMessage={`Amount`}/>}>
              {getFieldDecorator("amount", {
                initialValue: this.state.amount,
                rules: [{
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.amount_is_required"
                      defaultMessage={`Amount is required!`}
                    />
                  )
                }]
              })(
                <InputNumber/>
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.payment_at" defaultMessage={`Payment at`}/>}>
              {getFieldDecorator("payment_at", {
                initialValue: moment(this.state.payment_at),
                rules: [{
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.date_is_required"
                      defaultMessage={`Date is required!`}
                    />
                  )
                }]
              })(<Input type={`hidden`}/>)}
              <DatePicker
                isGregorian={false}
                timePicker={true}
                value={this.state.payment_at}
                onChange={this.onChangeDate}
              />{" "}
            </Form.Item>
          </Col>
          
          <Col span={24}>
            <Form.Item label={<FormattedMessage id="app.description" defaultMessage={`Description`}/>}>
              {getFieldDecorator("description")(
                <TextEditor ref={this.textEditorRef} text={this.state.description}/>
              )}
            </Form.Item>
          </Col>
        
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(
  Form.create({name: "supplierPayment-form"})(PaymentForm)
);
